import React from 'react';

import { useApp } from '../../store/AppContext';
import { eligiblePhasesForGeneral, phaseBrickId } from '../../utils/phases';
import { allBricks } from './allBricks';
import PhaseSelect from './unmatchedWorklogFields/PhaseSelect';

export default function UnmatchedWorklogFields({ canInclude, e, i }) {
  const { adminUsers, handleIncludeYear, appState, updateUnmatched } = useApp();
  const allBrickOptions = allBricks(appState.clients);
  return (
    <div className="grid [grid-template-columns:1fr_1fr_1fr_1fr_auto] gap-[5px]">
      <select
        className="text-[11px] py-[3px] px-[5px] [border:1px_solid_#ddd] rounded-[4px] bg-white"
        value={e.remapDevId || ''}
        onChange={(ev) => updateUnmatched(i, 'remapDevId', ev.target.value)}
      >
        <option value="">— Dev —</option>
        {adminUsers.map((u) => (
          <option key={u.id} value={u.id}>
            {u.nom || u.email}
          </option>
        ))}
      </select>
      <select
        className="text-[11px] py-[3px] px-[5px] [border:1px_solid_#ddd] rounded-[4px] bg-white"
        value={e.remapClientId || ''}
        onChange={(ev) => updateUnmatched(i, 'remapClientId', ev.target.value)}
      >
        <option value="">— Projet —</option>
        {(appState.clients || []).map((c) => (
          <option key={c.id} value={c.id}>
            {c.nom}
          </option>
        ))}
      </select>
      <PhaseSelect e={e} i={i} />
      <select
        className="text-[11px] py-[3px] px-[5px] [border:1px_solid_#ddd] rounded-[4px] bg-white"
        value={e.remapBriqueId || ''}
        onChange={(ev) => updateUnmatched(i, 'remapBriqueId', ev.target.value)}
        disabled={!e.remapPhaseId}
      >
        <option value="">— Brique —</option>
        {e.remapPhaseId && (
          <option value={phaseBrickId(e.remapPhaseId)}>⌂ Niveau phase (général)</option>
        )}
        {allBrickOptions
          .filter((b) => b.phaseId === e.remapPhaseId)
          .map((b) => (
            <option key={b.id} value={b.id}>
              {b.label}
            </option>
          ))}
      </select>
      <button
        className={`text-[11px] py-[2px] px-[8px] [border:none] rounded-[4px] ${canInclude ? 'cursor-pointer bg-success text-white' : 'cursor-default bg-[#e0e0e0] text-[#999]'}`}
        disabled={!canInclude}
        onClick={() => handleIncludeYear(e, i)}
      >
        ↑
      </button>
    </div>
  );
}
